import React, { useCallback, useState, useEffect } from 'react';
import { GuideNotes, NeuroMessage } from '@ignitesales/neuro-application';
import { Modal } from '@ignitesales/neuro-application/src/neuro-ui';
import PropTypes from 'prop-types';

const NotesComponent = ({ renderNotesIcon, shouldOpenModal }) => {
    const [showNotesModal, setShowNotesModal] = useState(false);
    
    useEffect(() => {
        if (shouldOpenModal) {
            setShowNotesModal(true);
        }
    }, [shouldOpenModal]);

    const handleOpenNotesModal = useCallback(() => {
        setShowNotesModal(true);
    }, []);

    const title = (
      <>
        {renderNotesIcon ? renderNotesIcon() : null}
        <NeuroMessage id="notes.title" />
      </>
    );

    const notesModal = (
        <Modal
            show={showNotesModal}
            onClose={() => setShowNotesModal(false)}
            className="modal--notes"
            title={title}
            nodeId="root"
            closeBtn={<i className="ion-md-close" />}
        >
            <div className="notes-container">
                <GuideNotes charactersRemaining={255} />
                <div className="notes-disclaimer-footer">
                    <small className="text-muted font-italic">
                        <NeuroMessage id="notes.disclaimer" />                        
                    </small>
                </div>
            </div>
        </Modal>
    );

    return (
        <>
            {notesModal}
            <ul className="branchMenu__options">
                <li>
                    <a onClick={handleOpenNotesModal}>
                        { renderNotesIcon ? renderNotesIcon() : <i className="ion-md-create" /> }
                        <NeuroMessage id="header.menu.notes"/>
                    </a>
                </li>
            </ul>
        </>
    );
};

NotesComponent.propTypes = {
    renderNotesIcon: PropTypes.func,
    shouldOpenModal: PropTypes.bool
};

export default NotesComponent; 